import { render, staticRenderFns } from "./TaskHis.vue?vue&type=template&id=406c6fa0&"
import script from "./TaskHis.vue?vue&type=script&lang=js&"
export * from "./TaskHis.vue?vue&type=script&lang=js&"
import style0 from "./TaskHis.vue?vue&type=style&index=0&id=406c6fa0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports